import { createContext } from 'react';
import useAuthentication from '../hooks/useAuthentication';

interface IAuthenticationActionContext {
    mutate: ReturnType<typeof useAuthentication>['mutate'],
}

const AuthenticationActionContext = createContext<IAuthenticationActionContext | null>(null);

export default AuthenticationActionContext;